import type { IPrintCommand, PaymentCardType } from "../entities/Commands";

export type KeyType = "pos" | "auth";
export type CardType = "nfc" | "qr";

export interface IPaymentCard {
    code: string;   
    payAuth?: string;
    uri: string;
    type: PaymentCardType;
}

export interface IReadCard {
    payToken?: string;
    title?: string;
    message?: string;
    amount?: number;
    type?: CardType;
}


export interface IWriteCard {
    uri?: string;
    title?: string;
    message?: string;
}


export interface IBarcode {
    code: string;   
    type: string;   
}

export interface IPrinter {
    model: string;
    name: string;
}


export interface IPaymentService {

    readCardAsync(options: IReadCard): Promise<IPaymentCard>;

    writeCardAsync(options: IWriteCard): Promise<boolean>;

    signPayloadPos(payload: string): string;

    getFingerprint(type: KeyType): string;

    signPayloadAuthAsync(payload: string): Promise<string>;

    listPrinters(): IPrinter[];

    print(printerModel: string, commandList: Partial<IPrintCommand>[]);
}

export function setPaymentService(service: IPaymentService) {
    paymentService = service;
}

export var paymentService: IPaymentService;